<template>
  <div class="yuncang" :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }">
    <van-nav-bar title="全部分类" left-arrow @click-left="onClickLeft" />
    <div class="main">
      <van-row>
        <van-col span="7" :style="height" class="leftContent">
          <ul class="sidebar">
            <li
              :class="categoryId == '热门大牌' ? 'current' : ''"
              @click="clickTab(null)"
              v-if="hotBrandList.length > 0"
            >
              热门大牌
            </li>
            <li
              v-for="(item, index) in categoryList"
              :key="index"
              :class="categoryId == item.id ? 'current' : ''"
              @click="clickTab(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </van-col>
        <van-col span="17" class="rightContent" :style="height">
          <div
            class="module"
            v-for="(items, index) in secondaryList"
            :key="index"
          >
            <h2>{{ items.name }}</h2>
            <van-row>
              <van-col
                span="8"
                class="col"
                v-for="(item, index) in items.children"
                :key="index"
                @click="goGoodsList(item)"
              >
                <div class="imgBox">
                  <img :src="item.icon" v-if="item.icon" alt="" />
                  <van-icon v-else name="photo-o" />
                </div>
                <p class="classifyName">{{ item.name }}</p>
              </van-col>
            </van-row>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      height: {
        height: document.body.clientHeight - 78 + "px",
      },
      isiOSX: false,
      categoryList: [],
      secondaryList: [],
      hotBrandList: [],
      categoryId: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    goGoodsList(item) {
      //品牌
      if (this.categoryId == "热门大牌") {
        if (item.params.brandId) {
          this.$router.push({
            path: "/yuncang/goodsList",
            query: { brandId: item.params.brandId },
          });
        }
      } else {
        //分类
        this.$router.push({
          path: "/yuncang/goodsList",
          query: { thirdCategory: item.id },
        });
      }
    },
    //获取分类列表
    getCategoryList() {
      this.$api
        .post("/ongoods/index/yc/category-list", {})
        .then((res) => {
          this.categoryList = res.list;
          if (this.hotBrandList.length > 0) {
            this.categoryId = "热门大牌";
            this.secondaryList = [
              {
                name: "国际大牌",
                children: this.hotBrandList,
              },
            ];
          } else {
            if (res.list[0]) {
              this.categoryId = res.list[0].id;
              this.secondaryList = res.list[0].children;
            }
          }
          this.Toast.clear();
        })
        .catch((err) => {
          this.Toast.clear();
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    //点击分类tab
    clickTab(item) {
      if (item) {
        this.categoryId = item.id;
        this.secondaryList = item.children;
      } else {
        this.categoryId = "热门大牌";
        this.secondaryList = [
          {
            name: "国际大牌",
            children: this.hotBrandList,
          },
        ];
      }
    },
    //获取热门品牌列表
    getBrandNav() {
      this.Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.$api
        .post("/ongoods/index/yc/index-nav", { tag: "yc_brand_nav", status: 1 })
        .then((res) => {
          this.hotBrandList = res.list;
          this.getCategoryList();
        })
        .catch((err) => {
          this.getCategoryList();
        });
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.isiOSX) {
      this.height = {
        height: document.body.clientHeight - 98 + "px",
      };
    }
  },
  mounted() {
    this.getBrandNav();
  },
};
</script>
<style lang="less" scoped>
.yuncang {
  background: #f5f6f7;
  height: 100%;
  box-sizing: border-box;
  .main {
    padding: 10px 0 0;
    .sidebar {
      padding-top: 15px;
      li {
        text-align: center;
        margin-bottom: 25px;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        font-weight: 400;
      }
      li.current {
        font-size: 18px;
        font-weight: 600;
        background: linear-gradient(to right, #fa2c2c, #ff6e40, #ff4e30);
        -webkit-background-clip: text;
        color: transparent;
        -webkit-text-fill-color: transparent;
        text-fill-color: transparent;
      }
    }
    .leftContent {
      -webkit-overflow-scrolling: touch;
      overflow-scrolling: touch;
      overflow-y: scroll;
    }
    .rightContent {
      -webkit-overflow-scrolling: touch;
      overflow-scrolling: touch;
      overflow-y: scroll;
      padding-right: 12px;
    }
    .module {
      background: #ffffff;
      padding: 10px 0;
      margin-bottom: 10px;
      border-radius: 6px;
      h2 {
        margin: 0;
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        color: #333333;
        padding: 0 12px;
      }
      .col {
        text-align: center;
        margin-top: 15px;
        .imgBox {
          width: 44px;
          height: 44px;
          margin: 0 auto;
          line-height: 44px;
          img {
            width: 44px;
            height: 44px;
          }
        }

        p {
          font-size: 12px;
          line-height: 22px;
          color: #666666;
          font-weight: 400;
          margin-top: 5px;
        }
      }
    }
  }
  .classifyName {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
<style lang="less">
.yuncang {
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: solid 1px #f5f6f7;
  }
}
</style>